import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { getData, addData, updateData, deleteData, getpastConfYears } from '../../services/pastConfAffilationsServices';
import { Modal, Button, Form } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import Header from '../../components/Layout/Header';
import Footer from '../../components/Layout/Footer';
import Sidebar from '../../components/Layout/Sidebar';
import Spinner from '../../components/Spinner';
import { toast } from 'react-toastify';

const Pastaffilations = () => {
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [dataList, setDataList] = useState([]);
  const [form, setForm] = useState({ id: '', year: '', speaker_name: '', speaker_university: '', speaker_country: ''});
  const [modalType, setModalType] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [searchText, setSearchText] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [pastConfYears, setpastConfYears] = useState([]);
  

  // Fetch data list
  const fetchData = useCallback(async () => {
    setLoading(true);
    try{
    const data = await getData();
    setDataList(data);
    }
    catch(error){
    console.error('Failed to fetching data:', error);
  }
  finally {
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

   useEffect(() => {
        const fetchpastConfYears = async () => {
          try {
            const data = await getpastConfYears(); // Fetch data from the service
            setpastConfYears(data); // Set the types in state
          } catch (error) {
            console.error('Error fetching data:', error);
          }
        };
     
        fetchpastConfYears();
      }, []);

  const validateForm = () => {
  const newErrors = {};
  if (!form.year) newErrors.year = "Year is required";
  if (!form.speaker_name) newErrors.speaker_name = "Speaker name is required";
  if (!form.speaker_university) newErrors.speaker_university = "Speaker University is required";
  if (!form.speaker_country) newErrors.speaker_country = "Speaker Country is required";

  setErrors((prev) => ({ ...prev, ...newErrors }));
  return Object.keys({ ...errors, ...newErrors }).every((key) => !errors[key] && !newErrors[key]);
};
 

  const handleChange = (e) => {
    try{
    const { name, value } = e.target;
    // Create a copy of the current form data
    let updatedData = { ...form };
    let updatedErrors = { ...errors };
    updatedData[name] = value;
      if (value) {
      updatedErrors[name] = ''; // Clear error if corrected
      } 
    setForm(updatedData);
    setErrors(updatedErrors);
    }
     catch (error) {
      console.error("Error in handleChange:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try{
      if (!validateForm()) {
        return
      }
    let response;
    if (modalType === 'add') {
     response = await addData(form);
     if (response.status === 201){
      toast.success("Saved Successfully!", {
                        position: 'top-right',
                      });
      }
      else{
        toast.error(response?.message ||"Failed to update data. Please try again.", {
                        position: 'top-right',
                      });
      }
    } else if (modalType === 'edit') {
     response = await updateData(form);
     if(response.status === 200){
     toast.success("Updated Successfully!", {
                        position: 'top-right',
                      });
    }
    }
    fetchData();  // Re-fetch data after adding/editing
    setShowModal(false);
  }
  catch (error) {
        console.error("Error during form submission:", error);
    }
  };

  const handleDelete = async () => {
    try{
    if (selectedData) {
      // Optimistically remove the data from the list
      setDataList((prev) => prev.filter((data) => data.id !== selectedData.id));
      // Proceed with the actual delete request
      await deleteData(selectedData);
      setShowDeleteConfirmModal(false);
    }
    }
    catch(error){
      console.error("Error during delete record:", error);
    }
  };

  const openModal = (type, data = { id: '', year: '', speaker_name: '', speaker_university: '', speaker_country: '' }) => {
    setModalType(type);
    setForm(data);
    setShowModal(true);
  };
  
  const openDeleteConfirmModal = (data) => {
    setSelectedData(data);
    setShowDeleteConfirmModal(true);
  };

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // Memoized filtered data based on search query
  const filteredData = useMemo(() => {
    const filtered =  dataList.filter(
      (data) =>
      data.speaker_name.toLowerCase().includes(searchText.toLowerCase()) 
    );
    const sortedData = [...filtered].sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
    return sortedData; 
  }, [dataList, searchText]);

  const columns = [
    {
      name: '#',
      selector: (row, index) => (currentPage - 1) * 10 + (index + 1),
      sortable: false,
      width: '80px',
    },
    {
      name: 'year',
      selector: (row) => row.year,
      cell: (row) => (
            <span title={row.year}>
              {row.year}
            </span>
          ),
      sortable: true,
    },
    {
      name: 'Speaker Name',
      selector: (row) => row.speaker_name,
      cell: (row) => (
            <span title={row.speaker_name}>
              {row.speaker_name}
            </span>
          ),
      sortable: true,
    },
    {
      name: 'Speaker University',
      selector: (row) => row.speaker_university,
      cell: (row) => (
            <span title={row.speaker_university}>
              {row.speaker_university}
            </span>
          ),
      sortable: true,
    },
    {
        name: 'Speaker Country',
        selector: (row) => row.speaker_country,
        cell: (row) => (
            <span title={row.speaker_country}>
              {row.speaker_country}
            </span>
          ),
        sortable: true,
      },
    {
      name: 'Actions',
      cell: (row) => (
        <div>
          <Button className="me-2" variant="warning" size="sm" onClick={() => openModal('edit', row)} > Edit </Button>
          <Button variant="danger" size="sm" onClick={() => openDeleteConfirmModal(row)} > Delete </Button>
        </div>
      ),
    },
  ];

  return (
    <div className="d-flex">
      <Sidebar />
      <div className="main-content w-100">
        <Header />
        {loading ? (
          <div className="d-flex justify-content-center align-items-center w-100" style={{ minHeight: "300px" }}>
          <Spinner />
        </div>
      ) :(
      <div>
        <div className="container-fluid p-4">
          <div className="row">
            <div className="col-8">
            <p className='mb-3 fs-4'>Past Events Pages / Past Conferences <b>/ Conference Attendees</b></p>
            </div>
            <div className="col-4 text-end">
              <button className="btn btn-primary mb-3" onClick={() => openModal('add')}>
                Add
              </button>
            </div>
          </div>

          {/* Data Table for data */}
          <DataTable
            columns={columns}
            data={filteredData}
            pagination
            search
            highlightOnHover
            responsive
            striped
            paginationPerPage={10}
            paginationComponentOptions={{
            noRowsPerPage: true,
            }}
            onChangePage={handlePageChange}
            subHeader
            subHeaderComponent={
              <div>
                <input className="form-control" type="text" placeholder="Search" value={searchText}
                  onChange={handleSearchChange}
                />
              </div>
            }
          />

          {/* Modal for Add/Edit data */}
          <Modal className="modal-lg" show={showModal} onHide={() => setShowModal(false)} backdrop="static">
            <Modal.Header closeButton>
              <Modal.Title className='fs-3'>{modalType === 'add' ? 'Add' : 'Edit'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form onSubmit={handleSubmit}>
              <div className="row">
                <Form.Group className="col-md-6 mb-3">
                <Form.Label className='form-label-custom'>Past Conference Year <small className='text-danger'> * </small></Form.Label>
                <Form.Control className="form-select mb-3" as="select" name="year" value={form.year} onChange={handleChange}  isInvalid={!!errors.year}>
                    <option value="">Select Year</option>
                    {pastConfYears.map((years) => (
                        <option key={years.year} value={years.year}>
                        {years.display_year}
                        </option>
                    ))}
                </Form.Control>
                <Form.Control.Feedback type="invalid">{errors.year}</Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="col-md-6 mb-3">
                  <Form.Label className='form-label-custom'>Speaker Name<small className='text-danger'> * </small></Form.Label>
                  <Form.Control type="text" name="speaker_name" value={form.speaker_name} onChange={handleChange} isInvalid={!!errors.speaker_name}/>
                  <Form.Control.Feedback type="invalid">{errors.speaker_name}</Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="col-md-6 mb-3">
                  <Form.Label className='form-label-custom'>Speaker University <small className='text-danger'> * </small></Form.Label>
                  <Form.Control type="text" name="speaker_university" value={form.speaker_university} onChange={handleChange} isInvalid={!!errors.speaker_university}/>
                  <Form.Control.Feedback type="invalid">{errors.speaker_university}</Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="col-md-6 mb-3">
                  <Form.Label className='form-label-custom'>Speaker Country <small className='text-danger'> * </small></Form.Label>
                  <Form.Control type="text" name="speaker_country" value={form.speaker_country} onChange={handleChange} isInvalid = {!!errors.speaker_country}/>
                  <Form.Control.Feedback type="invalid">{errors.speaker_country}</Form.Control.Feedback>
                </Form.Group>
                </div>
             
            <Modal.Footer className='border-0'>
              <Button variant="secondary" onClick={() => setShowModal(false)}> Cancel </Button>
              <Button variant="primary" type='submit' > {modalType === 'add' ? 'Add' : 'Save'} </Button>
            </Modal.Footer>
             </Form>
            </Modal.Body>
          </Modal>

          {/* Delete Confirmation Modal */}
          <Modal show={showDeleteConfirmModal} onHide={() => setShowDeleteConfirmModal(false)}>
            <Modal.Header closeButton>
              <Modal.Title>Delete</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>Are you sure you want to delete this row?</p>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowDeleteConfirmModal(false)}>
                Cancel
              </Button>
              <Button variant="danger" onClick={handleDelete}>
                Yes, Delete
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
        <Footer />
        </div>
      )}
      </div>
    </div>
  );
};

export default Pastaffilations;